import SystemFieldProto from '../../proto/system-field-proto';
import mapTaskType from "../../import/normalize/map-task-type";
import SystemFieldTaskTypeViewInImport from "./view-in-import";


export default class TaskTypeField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);

        this.type = gd.const.fields.type.TASK_TYPE;
    }

    static getValue(item) {return item.taskTypeId}

    get sortHintMessage() {
        return 'Sort by task type';
    }

    getCsvValue(item) {
        return gd.session.taskTypes.get(item.taskTypeId).name;
    }

    getValue(item) {return TaskTypeField.getValue(item)}

    getGroupObject(value) {
        const found = gd.session.taskTypes.get(value)

        return {
            id      : found ? found.id : value,
            value   : found ? found.id : value,
            label   : found ? found.name : value,
            name    : _.get(found, 'name', 'Not defined'),
        }
    }

    listItemGroupFunction() {
        return i=>TaskTypeField.getValue(i.item)
    }

    listItemSortFunctions(sort) {
        return {
            functions: [
                i => i.type === 'task' ? gd.session.taskTypes.get(i.item.taskTypeId).sortPosition : 0,
                i => i.type === 'task' ? gd.session.taskTypes.get(i.item.taskTypeId).name.toLowerCase() : 0,
            ],
            directions: [sort, sort]
        }
    }

    // IMPORT

    normalizeCSVValue(value) {
        return mapTaskType(gd.companyId, value);
    }

    getComponentViewInImport() {
        return SystemFieldTaskTypeViewInImport;
    }
}